enum CheckState {
  NONE,
  PARTIALLY_CHECKED,
  CHECKED,
}

export default CheckState
